import { Component, EventEmitter, OnInit, Output, Input, ViewChild, ElementRef } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { MaintenanceService } from '../../../techopsv4/services/maintenanceService';
import { Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { CommonModelService } from '../../../padu-reporting/capability/common-model.service';
import { ENTER } from '@angular/cdk/keycodes';
interface LobSegment {
  MasterSegment: string;
  lob_id: number;
  lob?: string;
  subLob: number[];
  selectedList: string[];
}
@Component({
    selector: 'app-add-remove-popup',
    templateUrl: './add-remove-popup.component.html',
    styleUrls: ['./add-remove-popup.component.css'],
    standalone: false
})
export class AddRemovePopupComponent implements OnInit {
  @Input() lobdropdwnDataSource;
  @Input() selectedInitiative: any;
  @Input() clearFormFields: boolean = false;
  @Output() addRemoveSuccessEvent: EventEmitter<any> = new EventEmitter();
  @Input() dataSource: any;
  @Input() popupName: any;
  @ViewChild('msidInput') msidInput: ElementRef;
  reqPayload: any;
  private subject: Subject<string> = new Subject();
  inputElement: any;
  users: any[];
  selectedUsers: any = {};
  setlobSublobToAll: boolean;
  seglobsubLob: any;
  msidText: any = '';
  role: any;
  clearAllSelection: boolean = false;
  showLoader: boolean = false;
  selectValues = [];
  disableMultiSelect: boolean = false;
  disableItems: any;
  separatorKeysCodes: number[] = [ENTER];
  architectAction: any = 'add';
  typeOfArchitect: any = '';
  cioMappingList: any = [];
  roleList = [];
  CAList: any;
  ADList: any;
  msidsArr: any;
  openAllPanel: boolean = false;
  hierarchyDropdownConfig = {
    parentfield: ['SegID', 'MasterSegment'],
    firstchildfield: ['lob_id', 'lob'],
    secondchildfield: ['SubLobID', 'sub_lob', 'subLob'],
    firstchildkey: 'lob',
    secondchildkey: 'subLob',
  };
  actualcioMappingList: any;
  ExCAList: any[];
  existingADList: any[];
  roleaccessDtl: any;
  ExUsersList: any = {};
  constructor(private maintenanceService: MaintenanceService, private capabilityService: CommonModelService,
    private toastr: ToastrService) { }


  ngOnInit(): void {
    this.selectedUsers = {};
    if (this.popupName == 'AddRemoveRole') {
      this.getRoleDrpdwnLst();
      this.filterExistingUsersList();
    } else if (this.popupName == 'AddRemoveArchitect') {
      this.filterExistingCAUsersList();
      this.roleList = ['Chief Architect', 'Architect Delegate'];
    }
    this.getLobdata();
    this.subject.pipe(
      debounceTime(500)
    ).subscribe(searchObj => {
      this.handleSearch(searchObj);
    });
  }

  ngOnChanges() {
    if (this.clearFormFields) {
      this.clearSelectedUserandLob();
      this.typeOfArchitect = '';
      if(this.msidInput && this.msidInput.nativeElement){
        this.msidInput.nativeElement.value = '';
      }
    }
    if (this.dataSource) {
      if (this.popupName == 'AddRemoveRole') {
        this.filterExistingUsersList();
      } else if (this.popupName == 'AddRemoveArchitect') {
        this.filterExistingCAUsersList();
      }
    }
  }

  submit() {
    if (this.popupName == 'AddRemoveRole') {
      const reqPayload = {
        "add": {},
        "remove": {}
      }
      const seglobsubLOB = this.seglobsubLob;
      if(seglobsubLOB && seglobsubLOB.length > 0){
        seglobsubLOB.map(item=> {
          if(item.subLob && item.subLob.length > 0){
            item.sublob = [...item.subLob];
            delete item.subLob;
          }
        })
      }
      reqPayload[this.architectAction] = {
        "initiative_id": this.selectedInitiative.initiative_ID,
        "role": this.typeOfArchitect,
        "data": seglobsubLOB,
        "names": []
      }
      reqPayload[this.architectAction]['names'].push(this.selectedUsers);
      if (this.disableMultiSelect) {
        const selectedLOBSUBLOb = [
          {
            "lob": "All",
            "sublob": ["All"]
          }];
        reqPayload[this.architectAction]['data'] = selectedLOBSUBLOb;
      }
      this.addRemoveSuccessEvent.emit(reqPayload);
      this.clearSelectedUserandLob();
    } else if (this.popupName == 'AddRemoveArchitect') {
      if (this.selectedUsers.MSId) {
        this.selectedUsers['msid'] = this.selectedUsers.MSId;
        delete this.selectedUsers.MSId;
      }
      const reqBody = {
        action: this.architectAction,
        type_of_architect: this.typeOfArchitect,
        msid: this.selectedUsers,
        dataArr: this.seglobsubLob
      };
      this.showLoader = true;
      this.maintenanceService.addRemoveUsers(reqBody).subscribe(res => {
        if (res) {
          this.showLoader = false;
          this.toastr.success(res, '', { positionClass: 'toast-top-center', timeOut: 2000, })
          this.addRemoveSuccessEvent.emit(reqBody);
          this.clearSelectedUserandLob();
        }
      }, (error) => {
        console.error(error);
        this.showLoader = false;
        this.toastr.error("Something went wrong, Please try again later.", '', { positionClass: 'toast-top-center', timeOut: 1000, })
      });
    }

  }

  getRoleDrpdwnLst() {
    const payload = {
      "initiativeID": this.selectedInitiative.initiative_ID
    };
    this.showLoader = true;
    this.maintenanceService.getEIRoles(payload).subscribe((response) => {
      this.showLoader = false;
      if (response && response.roles?.length > 0) {
        this.roleaccessDtl = response;
        this.roleList = response.roles;
      } else {
        this.roleList = [];
      }
    }, (error) => {
      console.error(error);
      this.showLoader = false;
      this.showErrMsg(error);
    });
  }

  architectActionChange(event) {
    this.architectAction = event.value;
    this.clearSelectedUserandLob();
    this.roleSelected(this.typeOfArchitect);
  }
  
  clearSelectedUserandLob() {
    this.openAllPanel = false;
    this.selectedUsers = {};
    this.selectValues = [];
    this.users = [];
    this.clearFormFields = false;
    this.disableMultiSelect = false;
    this.cioMappingList = (this.architectAction == 'remove' && this.selectedUsers?.displayName) ? this.filterSUBList() : JSON.parse(JSON.stringify(this.actualcioMappingList || []));
  }

  filterSUBList() {
    const msidsArray = [];
    this.dataSource.forEach(lob => {
      let tempobj: any = {};
      if (this.popupName == 'AddRemoveRole') {
        tempobj = {
          "master_segment": lob.Master_Segment,
          "lob": lob.lob,
          "lob_id": lob.lobId,
          "subLob": []
        }
        if (this.roleaccessDtl?.Full_Access_Role?.includes(this.typeOfArchitect)) {
          this.selectValues = [];
          this.disableMultiSelect = true;
        } else {
          lob.subLob.forEach(element => {
            const msidList = element['users'].map(x => x.MSId);
            if (element.role == this.typeOfArchitect && msidList.includes(this.selectedUsers.MSId)) {
              tempobj.subLob.push({ 'sub_lob': element.Sub_LOB, 'SubLobID': element.subLobID });
            }
          });
        }

      } else if (this.popupName == 'AddRemoveArchitect') {
        tempobj = {
          "master_segment": lob.MasterSegment,
          "lob": lob.CIOLOB,
          "lob_id": lob.LobID,
          "subLob": []
        }
        lob.sublob.forEach(element => {
          const architectTyp = (this.typeOfArchitect == 'Chief Architect') ? 'ChiefArchitect' : 'ArchitectDelegate';
          const msidList = element[architectTyp].map(x => x.msid)
          if (msidList.includes(this.selectedUsers.msid)) {
            tempobj.subLob.push({ 'sub_lob': element.SubLineofBusiness, 'SubLobID': element.SubLobID });
          }
        });
      }

      tempobj.subLob.length ? msidsArray.push(tempobj) : false;
    });
    // this.openAllPanel = true;
    return this.formatList(msidsArray);
  }

  getLobdata() {
    this.showLoader = true;
    this.maintenanceService.getLOBList().subscribe(
      (response: any) => {
        this.showLoader = false;
        if (response && response.length) {
          console.log('response', response);
          this.cioMappingList = this.formatList(response);
          console.log('cioMappingList', this.cioMappingList);
          this.actualcioMappingList = JSON.parse(JSON.stringify(this.cioMappingList))
        }
      },
      (err) => {
        this.showLoader = false;
        this.showErrMsg(err);
      }
    );
  }


  formatList(list: any) {
    const filterValues = [...new Set(list.map((ele: { master_segment: any; }) => ele.master_segment))];
    const finalList: any = [];
    filterValues.forEach((ele: any) => {
      const filteredList = list.filter((item: { master_segment: any; }) => ele == item.master_segment);

      // Transform LOB data to normalize field names
      const transformedLobList = filteredList.map((lobItem: any) => this.transformLobData(lobItem));

      const tempobj = {
        MasterSegment: filteredList[0]?.master_segment,
        name: filteredList[0]?.master_segment,
        id: filteredList[0]?.master_segment,
        children: transformedLobList
      };
      finalList.push(tempobj);
    });


    return finalList;
  }

  /**
   * Transforms LOB data to normalize field names
   * Converts lob_id to id, sub_lob to name in subLob array
   * @param lobItem LOB item from API response
   * @returns Transformed LOB object with normalized field names
   */
  transformLobData(lobItem: any): any {
    return {
      master_segment: lobItem.master_segment,
      lob: lobItem.lob,
      lob_id: lobItem.lob_id,
      id: lobItem.lob_id, // Normalize: lob_id as id
      name: lobItem.lob, // Normalize: lob as name
      children: (lobItem.subLob || []).map((subItem: { sub_lob: any; SubLobID: any; }) => ({
        sub_lob: subItem.sub_lob,
        SubLobID: subItem.SubLobID,
        id: subItem.SubLobID, // Normalize: SubLobID as id
        name: subItem.sub_lob // Normalize: sub_lob as name
      }))
    };
  }
  showErrMsg(err: any) {
    this.showLoader = false;
    if (err && err.message) {
      this.toastr.error(err.message, '', {
        timeOut: 10000,
        positionClass: 'toast-top-center'
      });
    }
  }
  filterExistingCAUsersList() {
    this.ExCAList = this.extractUniqueUsers('ChiefArchitect');
    this.existingADList = this.extractUniqueUsers('ArchitectDelegate');
  }

  private extractUniqueUsers(architectType: string): any[] {
    const usersList = this.getAllUsersOfType(architectType);
    return this.removeDuplicateUsers(usersList);
  }

  private getAllUsersOfType(architectType: string): any[] {
    return this.dataSource.flatMap(element => 
      element.sublob.flatMap(sblob => sblob[architectType])
    );
  }

  private removeDuplicateUsers(usersList: any[]): any[] {
    const uniqueUsers = [];
    usersList.forEach(user => {
      if (!this.isUserAlreadyAdded(uniqueUsers, user.msid)) {
        uniqueUsers.push(user);
      }
    });
    return uniqueUsers;
  }

  private isUserAlreadyAdded(usersList: any[], msid: string): boolean {
    return usersList.some(item => item.msid === msid);
  }



  filterExistingUsersList() {
    const existingUsers = {};
    const allSubLobs = this.getAllSubLobsWithUsers();
    
    allSubLobs.forEach(subLob => {
      this.processUsersForRole(existingUsers, subLob.role, subLob.users);
    });
    
    this.ExUsersList = existingUsers;
  }

  private getAllSubLobsWithUsers(): any[] {
    return this.dataSource.flatMap(element =>
      element.subLob.map(sblob => ({
        role: sblob.role,
        users: sblob.users
      }))
    );
  }

  private processUsersForRole(existingUsers: any, role: string, users: any[]): void {
    users.forEach(user => {
      this.addUserToRoleIfNotExists(existingUsers, role, user);
    });
  }

  private addUserToRoleIfNotExists(existingUsers: any, role: string, user: any): void {
    if (!existingUsers[role]) {
      existingUsers[role] = [];
    }
    
    if (!this.isUserInRole(existingUsers[role], user.MSId)) {
      existingUsers[role].push(user);
    }
  }

  private isUserInRole(roleUsers: any[], msId: string): boolean {
    return roleUsers.some(item => item.MSId === msId);
  }

  keyUpSearch(name) {
    const p: any = {}
    p['search'] = name.target.value;
    this.inputElement = name;
    if (this.architectAction == 'remove') {
      this.users = [];
      if (this.typeOfArchitect == 'Chief Architect') {
        this.users = this.ExCAList.filter(obj =>
          obj.msid?.toLowerCase().includes(name.target.value.toLowerCase()) || obj.displayName?.toLowerCase().includes(name.target.value.toLowerCase()) || obj.mail?.toLowerCase().includes(name.target.value.toLowerCase())
        );
      } else if (this.typeOfArchitect == 'Architect Delegate') {
        this.users = this.existingADList.filter(obj =>
          obj.msid?.toLowerCase().includes(name.target.value.toLowerCase()) || obj.displayName?.toLowerCase().includes(name.target.value.toLowerCase()) || obj.mail?.toLowerCase().includes(name.target.value.toLowerCase())
        );
      } else if (this.popupName == 'AddRemoveRole' && this.typeOfArchitect != '') {
        this.users = this.ExUsersList[this.typeOfArchitect].filter(obj =>
          obj.MSId?.toLowerCase().includes(name.target.value.toLowerCase()) || obj.displayName?.toLowerCase().includes(name.target.value.toLowerCase()) || obj.mail?.toLowerCase().includes(name.target.value.toLowerCase())
        );
      }
      else {
        this.subject.next(p);
      }
    }
    else if (this.architectAction != 'remove' && name.target.value) {
      this.subject.next(p);
    }
    else {
      this.users = [];
    }
  }

  selected(event) {
    this.disableItems = [];
    if (event.option.value.givenName !== '') {
      this.selectedUsers = event.option.value;
      if (this.inputElement) {
        this.inputElement.target.value = '';
        this.users = []
      }
      this.cioMappingList = (this.architectAction == 'remove' && this.selectedUsers?.displayName) ? this.filterSUBList() : JSON.parse(JSON.stringify(this.actualcioMappingList || []));
      this.checkDisability();



    }
  }
  getCAADLOBList(SubLobID) {
    let msidsArray = [];
    this.dataSource.forEach(lob => {
      const element = lob.sublob ? lob.sublob.filter(x => x.SubLobID == SubLobID) : lob.subLob.filter(x => x.subLobID == SubLobID)
      if (element.length) {
        if (this.typeOfArchitect == "Chief Architect") {
          msidsArray = element[0].ChiefArchitect.map(item => item.msid);
        } else if (this.typeOfArchitect == "Architect Delegate") {
          msidsArray = element[0].ArchitectDelegate.map(item => item.msid);
        } else {
          msidsArray = element[0].users.map(item => item.MSId);
        }
        return msidsArray;
      }

    });
    return msidsArray;
  }

  checkDisability() {
    if (this.architectAction != 'remove') {
      this.openAllPanel = false;
      this.msidsArr = [];
      this.cioMappingList.forEach(segment => {
        segment.lob.forEach(eachlob => {
          eachlob.subLob.forEach(element => {
            this.msidsArr = this.getCAADLOBList(element.SubLobID);
            element['disable'] = this.selectedUsers?.MSId && this.msidsArr.includes(this.selectedUsers.MSId) && this.architectAction == "add" ? true : false;
          });
        })
      });
    }
  }
  architectTypeChange() {
    this.clearSelectedUserandLob();
    this.roleSelected(this.typeOfArchitect);
  }

  roleSelected(role) {
    this.setlobSublobToAll = false;
    if (this.roleaccessDtl?.Full_Access_Role?.includes(role) && this.architectAction == 'add') {
      this.selectValues = this.getAllSubLOB();
      this.disableMultiSelect = true;
    } else {
      this.selectValues = [];
      this.disableMultiSelect = false;
    }
    this.selectedUsers = {};
  }

  getAllSubLOB() {
     return (this.cioMappingList || []).flatMap(segment =>
      (segment?.children || []).flatMap(lob =>
        (lob?.children || []).map(subLob => subLob.SubLobID)
      )
    );
  }

  remove() {
    this.clearSelectedUserandLob();
    this.roleSelected(this.typeOfArchitect);
  }
  checkexist(user) {
    if (this.popupName == 'AddRemoveRole' && this.typeOfArchitect && this.ExUsersList[this.typeOfArchitect]) {
      const userhasaccessalready = this.ExUsersList[this.typeOfArchitect].filter(x => x.MSId == user.MSId);
      return (userhasaccessalready.length > 0 && this.roleaccessDtl.Full_Access_Role.includes(this.typeOfArchitect) && this.architectAction == "add" ? true : false);
    } else {
      return false;
    }

  }

  handleSearch(searchObj) {
    const value = searchObj['search'];
    const column = searchObj['column'];
    if (value) {
      this.capabilityService.getLDAPUsers(value).subscribe(dataStream => {
        this.users = [];
        dataStream.forEach(element => {
          this.users.push({
            givenName: element.givenName,
            sn: element.sn,
            mail: element.mail,
            displayName: element.displayName,
            employeeID: element.employeeID,
            MSId: element.cn,
            middleName: element.middleName,
          });
        });
      }, (error) => {
        console.error(error);
      });
    } else {
      column.options = [];
    }
  }
  setSelectedAllLob(data: any[]): void {
     const allSelectedList = new Set<string>();
     // First pass: collect all selected values
     this.cioMappingList.forEach(segment => {
       segment.children.forEach(lob => {
         lob.children.forEach(sub => {
           if(!data[0].__excludePaths || !data[0].__excludePaths.some(path => path.L1 === segment.MasterSegment && path.L2 === lob.lob && path.L3 === sub.sub_lob)) {
             allSelectedList.add(`${segment.MasterSegment}-${lob.lob_id}-${sub.SubLobID}`); // Collect all selected values
           }
         });
       });
     });
     const consolidatedData: LobSegment[] = this.cioMappingList.flatMap(segment => {
       return segment.children.map(lob => {
         const subLobIds = lob.children
           .filter(sub => !data[0].__excludePaths || !data[0].__excludePaths.some(path => path.L1 === segment.MasterSegment && path.L2 === lob.lob && path.L3 === sub.sub_lob))
           .map(sub => sub.SubLobID);
           if(!subLobIds.length) {
             return null; // Skip if no subLobIds are selected for this lob
           }
           return {
             MasterSegment: segment.MasterSegment,
             lob_id: lob.lob_id,
             subLob: subLobIds,
             selectedList: Array.from(allSelectedList)
           } as LobSegment;
       });
     }).filter(item => item !== null);
     this.selectedHierarchy(consolidatedData);
   }
  setSelectedLobValues(data: any[]): void {
     if(data?.length > 0) {
       // Initialize collections to store unique values and consolidate data
       if(data[0].__selectAll__) {
         return this.setSelectedAllLob(data);
       }
       const segmentMap = new Map();
       const lobSet = new Set();
       const sublobSet = new Set();
       const selectedList = new Set();
       const consolidatedData: LobSegment[] = [];

       // Process each data item
       data.forEach((item: { hasOwnProperty: (arg0: string) => any; MasterSegment: any; lob_id: any; subLob: never[]; L1: any; L2: any; L3: any; }) => {
         let segment, lob, sublobs = [];

       if (item.hasOwnProperty('L1')) {
           // Old format
           segment = item.L1;
           lob = this.fetchIds(item.L1, item.L2);
           sublobs = item.L3 ? [this.fetchSubLobId(item.L1, item.L2,item.L3)] : [];
           selectedList.add(`${item.L1}-${lob}-${sublobs[0]}`);
         } else {
           return; // Skip invalid items
         }

         // Store segment with its lobs for consolidation
         if (!segmentMap.has(segment)) {
           segmentMap.set(segment, new Map());
         }

         const lobMap = segmentMap.get(segment);
         if (!lobMap.has(lob)) {
           lobMap.set(lob, new Set());
         }

         // Add sublobs to the set
         sublobs.forEach((sub: unknown) => {
           if (sub) {
             lobMap.get(lob).add(sub);
             sublobSet.add(sub);
           }
         });

         // Add lob
         if (lob) {
           lobSet.add(lob);
         }
       });

       // Build consolidated data in new format (MasterSegment, lob_id, subLob)
       segmentMap.forEach((lobMap, segment) => {
         lobMap.forEach((sublobSet: Iterable<unknown> | ArrayLike<unknown>, lob: any) => {
           consolidatedData.push({
             MasterSegment: segment,
             lob_id: lob,
             subLob: Array.from(sublobSet) as number[],
             selectedList: Array.from(selectedList)
           } as LobSegment);
         });
       });

       this.selectedHierarchy(consolidatedData);
     } else if(data?.length === 0) {
       this.selectedHierarchy([]);
     }
   }
  fetchIds(l1: any, l2: any) {
    const data = this.cioMappingList.find((item: { MasterSegment: any; }) => item.MasterSegment === l1)
    if(!data) return null;
    const lob = data.children.find((item: { lob: any; }) => item.lob === l2);
    return lob ? lob.lob_id : null;
  }
  fetchSubLobId(l1: any, l2: any, l3: any) {
    try {
      const data = this.cioMappingList.find((item: { MasterSegment: any; }) => item.MasterSegment === l1)
      if(!data) return null;
      const lob = data.children.find((item: { lob: any; }) => item.lob === l2);
      if(!lob) return null;
      const subLob = lob.children.find((item: { sub_lob: any; }) => item.sub_lob === l3);
      return subLob ? subLob.SubLobID : null;
    } catch (error) {
      return null;
    }
  }
  selectedHierarchy(data) {
    this.seglobsubLob = data.map(item => ({lob: item.lob_id, subLob: item.subLob})); 
  }
  disableSubmit() {
    if (this.popupName == 'AddRemoveRole' && this.roleaccessDtl?.Full_Access_Role?.includes(this.typeOfArchitect)) {
      return (this.typeOfArchitect && (this.selectedUsers && this.selectedUsers.displayName) ? false : true);
    } else {
      return (this.typeOfArchitect && this.seglobsubLob && this.seglobsubLob.length > 0 && (this.selectedUsers && this.selectedUsers.displayName) ? false : true);
    }
  }

}
